export const chunk = <T>(input: T[], size?: number) =>
    input.reduce(
        (arr, item, idx) =>
            idx % (size || input.length) === 0 ? [...arr, [item]] : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]],
        [] as T[][]
    );
